// Import all images
import WashingMachines2 from 'assets/images/image_14.webp';
import Machines1 from 'assets/images/image_11.webp';
import Machines2 from 'assets/images/image_10.webp';
import Machines from 'assets/images/image_15.webp';
import Laundromat from 'assets/images/laundromat.webp';
import PaymentsImage from 'assets/images/image_12.webp';
import Baskets from 'assets/images/image_6.webp';

import aboutMachines from "assets/images/image_2.webp";
import aboutMachines2 from "assets/images/image_5.webp";

// Export individual images
export const images = {
    locations: {
        hamilton: WashingMachines2,
    },
    home: {
        hero: Laundromat,
        moreInfo: {
            mission: Machines1,
            sustainability: Machines2,
            blog: Machines
        }
    },
    loyalty: {
        machines: Machines1,
        payments: PaymentsImage,
        baskets: Baskets,
        machines2: Machines2
    },
    about: {
        machines: aboutMachines,
        machines2: aboutMachines2
    }
};

// Export image types for type safety
export type LocationImages = typeof images.locations;
export type HomeImages = typeof images.home;
export type LoyaltyImages = typeof images.loyalty;
export type aboutImages = typeof images.about;